import React, { useState } from 'react';
import { TiArrowSortedDown } from 'react-icons/ti';
import { useTranslation } from 'react-i18next';

export default function LayoutRow({
  item, styles, onChange, isDraftChanged,
}) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  async function handleChange(data) {
    setIsOpen(!isOpen);
    onChange(data);
  }

  return (
    <div className={`${styles.row} ${isDraftChanged ? styles.draftChanged : ''}`}>
      <div className={styles.col}>
        <p>{item.position}</p>
      </div>
      <div className={styles.col}>
        <p>{item.name}</p>
      </div>
      <div className={styles.col} onClick={() => setIsOpen(!isOpen)} >
        <div className={styles.select}>
          <p>
            {item.size === 'col-1' && t('dashboard.size.1')}
            {item.size === 'col-2' && t('dashboard.size.2')}
            {item.size === 'col-3' && t('dashboard.size.3')}
            {item.size === 'col-4' && t('dashboard.size.4')}
          </p>
          {isOpen
            && <ul>
              <li onClick={() => handleChange({ size: 'col-1' })}>
                {t('dashboard.size.1')}
              </li>
              <li onClick={() => handleChange({ size: 'col-2' })}>
                {t('dashboard.size.2')}
              </li>
              <li onClick={() => handleChange({ size: 'col-3' })}>
                {t('dashboard.size.3')}
              </li>
              <li onClick={() => handleChange({ size: 'col-4' })}>
                {t('dashboard.size.4')}
              </li>
            </ul>
          }
        </div>
        <div
          className={styles.toggle}
        >
          <TiArrowSortedDown />
        </div>
      </div>
    </div>
  );
}
